import { TaskLabel } from './taskLabel';
import { TaskStatus } from './taskStatus';
export class Task {

  id: string;

  projectId: string;
  ownerId: string;
  name: string;
  status: TaskStatus;
  details: string;
  dueDate: Date;
  label: TaskLabel;
  createdOn: Date;
  createdBy: string
  updatedOn: Date;
  updatedBy: string;
}
